import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import store from "./store";

Vue.use(Router);
let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      props: true,
      // component: () => import("./layout/DefaultNEW"), 
      component: () => import("./layout/DefaultUpdated"),
      meta: {
        requiresAuth: true,
      },
      children: [


        {
          path: "news",
          name: "news",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./News/news"),
        },
        {
          path: "settings",
          name: "settings",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./settings/DeliverDistancePage"),
        },
        {
          path: "promocode",
          name: "promocode",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/promocode/addPromocode"),
        },
        {
          path: "HSNList",
          name: "HSNList",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./HSN/codeList"),
        },
        {
          path: "promocodeView",
          name: "promocodeView",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/promocode/promoDetails"),
        },
        {
          path: "",
          name: "dashboard",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Dashboard/Dashboard"),
        },
        {
          path: "CustomerList",
          name: "CustomerList",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Customer/customerList"),
        },
        {
          path: "CustomerInfo",
          name: "CustomerInfo",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Customer/customerInfo"),
        },
        {
          path: "myorders",
          name: "order",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Customer/myorders"),
        },
        {
          path: "GroceryListPage",
          name: "GroceryListPage",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Customer/GroceryListPage"),
        },



        {
          path: "SellerList",
          name: "SellerList",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Seller/sellerList"),
        },
        {
          path: "privacypolicy",
          name: "privacypolicy",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/TermsandPolicies/privacyPolicy.vue"),
        },
        {
          path: "termsandConditions",
          name: "termsandConditions",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/TermsandPolicies/termsandConditions.vue"),
        },
        {
          path: "cancellationPolicy",
          name: "cancellationPolicy",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/TermsandPolicies/cancellationPolicy.vue"),
        },
        {
          path: "SellerInfo",
          name: "SellerInfo",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Seller/sellerInfo"),
        },

        {
          path: "editSeller",
          name: "editSeller",
          meta: {
            requiresAuth: true,
          },
          component: () =>
            import("./views/Users/Seller/edit/editSellerProfile"),
        },

        {
          path: "ViewProducts",
          name: "ViewProducts",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Seller/viewProducts"),
        },
        {
          path: "filterViewProducts",
          name: "filterViewProducts",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Seller/filterProducts"),
        },
        {
          path: "shopProducts",
          name: "shopProducts",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/product/filterProducts"),
        },
        {
          path: "Food",
          name: "Food",
          meta: {
            requiresAuth: true,
          },

          component: () =>
            import("./views/Users/Product/productList"),
        },
        {
          path: "promotedProducts",
          name: "promotedProducts",
          meta: {
            requiresAuth: true,
          },
          component: () =>
            import("./views/Users/Product/promotedProducts"),
        },
        {
          path: "Groceryproduct",
          name: "Grocery product",
          meta: {
            requiresAuth: true,
          },
          component: () =>
            import("./grocery/product/productList"),
        },
        {
          path: "ProductInfo",
          name: "ProductInfo",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Product/productInfo"),
        },
        {
          path: "ProductType",
          name: "ProductType",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/ProductType/productType"),
        },

        // {
        //   path: "addProduct",
        //   name: "addProduct",
        //   meta: {
        //       requiresAuth: true,
        //   },
        //   component: () =>
        //       import ("./views/Users/Product/addProductDynamic"),
        // },
        {
          path: "addProduct",
          name: "addProduct",
          props: true,
          meta: {
            requiresAuth: true,
          },
          component: () =>
            import("./views/Users/Product/Dynamic/addProductDynamic"),
        },




        //   {
        //     path: "editProduct",
        //     name: "editProduct",
        //     meta: {
        //         requiresAuth: true,
        //     },
        //     component: () =>
        //         import ("./views/Users/Product/edit/editProduct"),
        // },

        {
          path: "editProduct",
          name: "editProduct",
          meta: {
            requiresAuth: true,
          },
          component: () =>
            import("./views/Users/Product/edit/dynamicEdit/editProductDynamic"),
        },



        {
          path: "editProduct",
          name: "editProduct",
          meta: {
            requiresAuth: true,
          },
          component: () =>
            import("./views/Users/Product/edit/editProductDynamic"),
        },



        {
          path: "ProductSubType",
          name: "ProductSubType",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/ProductType/productSubType"),
        },

        {
          path: "OrderList",
          name: "OrderList",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Order/orderList"),
        },
        {
          path: "OrderInfo",
          name: "OrderInfo",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Order/orderInfo"),
        },
        {
          path: "offers",
          name: "offers",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Offers/offers"),
        },
        {
          path: "advertisements",
          name: "advertisements",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/Advertisements/advertisements"),
        },
        
        {
          path: "deliveryCharges",
          name: "deliveryCharges",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/DeliveryCharges/deliveryCharges"),
        },

        
        // {
        //   path: "delivery",
        //   name: "delivery",
        //   meta: {
        //     requiresAuth: true,
        //   },
        //   component: () => import("./views/Users/DeliveryCharges/delivery"),
        // },




        {
          path: "salesAnalytics",
          name: "salesAnalytics",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/Users/SalesAnalytics/salesAnalytics"),
        },

        {
          path: "SubCategory",
          name: "SubCategory",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/ProductType/subCategory"),
        },


        {
          path: "Brand",
          name: "Brand",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/brand/brandList"),
        },
        {
          path: "GroceryOrderInfo",
          name: "GroceryOrderInfo",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/Order/orderInfo"),
        },

        {
          path: "groceryOrderList",
          name: "groceryOrderList",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/Order/orderList"),
        },

        {
          path: "Gocerycategory",
          name: "GoceryCategory",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/manageCategory/Category"),
        },

        {
          path: "Gocerysubcategory",
          name: "GocerysubCategory",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/manageCategory/Subcategory"),
        },

        {
          path: "AddGroceryProduct",
          name: "AddGroceryProduct",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/product/addProduct"),
        },

        {
          path: "Stocks",
          name: "Stocks",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/stock/stocks"),
        },
        {
          path: "previousStock",
          name: "previousStock",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/stock/previousStock"),
        },
        {
          path: "Stocksmanagement",
          name: "StocksManagement",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/stock/stockManagement"),
        },
        {
          path: "notifymelist",
          name: "notifyme",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/stock/notifyMeList.vue"),
        },

        {
          path: "Q&A",
          name: "Q&A",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/User/Q&A"),
        },


        {
          path: "EditGroceryProduct",
          name: "EditGroceryProduct",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/product/editproduct"),
        },
        {
          path: "GroceryProductList",
          name: "GroceryProductList",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/product/productList"),
        },
        {
          path: "GroceryProductInfo",
          name: "GroceryProductInfo",
          props: true,
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/product/productInfo"),
        },
        {
          path: "GocerySeller",
          name: "GocerysubCategory",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/User/Userlist"),
        },
        {
          path: "GrocerySellerInfo",
          name: "GrocerySellerInfo",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/User/sellerInfo"),
        },

        // {
        //   path: "deliveryCharge",
        //   name: "deliveryCharge",
        //   meta: {
        //     requiresAuth: true,
        //   },
        //   component: () => import("./grocery/deliveryCharge/deliveryCharge"),
        // },
        {
          path: "delivery",
          name: "delivery",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/deliveryCharge/delivery"),
        },







        {
          path: "groceryBanner",
          name: "groceryBanner",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/banner/banner"),
        },
        {
          path: "deals",
          name: "deals",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./grocery/deals/deals"),
        },



        // {
        //   path: "/add",
        //   name: "adds",
        //   meta: {
        //     requiresAuth: true,
        //   },
        //   component: () => import("./views/Admins/addMenu"),
        // },
      ],
    },
    {
      path: "/",
      props: true,
      component: () => import("./layout/Authentication"),
      meta: {
        requiresAuth: false,
      },
      children: [
        // {
        // 	path: 'login',
        // 	name: 'login',
        // 	meta: {
        // 		requiresAuth: false,
        // 	},
        // 	component: () => import('./views/Authentication/Login')
        // },
        {
          path: "login",
          name: "login",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Authentication/adminLogin"),
        },
        {
          path: "signup",
          name: "signup",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Authentication/Signup"),
        },
        {
          path: "privacypolicies",
          name: "privacypolicy",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/TermsandPolicies/privacyPolicies.vue"),
        },
      ],
    },

    {
      path: "/servererror",
      name: "servererror",
      props: true,
      component: () => import("./layout/500"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "*",
      name: "404pagenotfound",
      props: true,
      component: () => import("./layout/404"),
      meta: {
        requiresAuth: false,
      },
    },
  ],
  scrollBehavior() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  },

});
router.beforeEach((to, from, next) => {
  localStorage.setItem("LS_ROUTE_KEY", from.path);


  if (
    to.matched.some((route) => route.meta.requiresAuth == true) &&
    store.state.isLoggedIn == false
  ) {
    console.log(from);
    next({ name: "login", params: { lastPage: from } });
    return;
  }
  if (store.state.isLoggedIn == true) {
    axios({
      method: "POST",
      url: "authenticate/admin",
      headers: {
        token: localStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (!response.data.status) {
          store.commit("sessionOut", true);
          return;
        }
      })
      .catch((err) => {
        var msg = err;
        console.log(msg);
      });
  }
  if (
    (to.name == "login" || to.name == "home") &&
    store.state.isLoggedIn == true
  ) {
    next({ name: "dashboard" });
    return;
  }
  next();
});

export default router;
